import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { getErrorFormat } from 'core/utils/errors';
import { AccessDevicesListResponseModel, AccessDevicesListResponsePayload, AccessDeviceSortModel } from '../models';
import { payloadToAccessDevicesListByProjectIdResponse } from '../mappers';

const getSortParams = (sort: AccessDeviceSortModel[]): string => {
  const transformedSortParams: string[] = [];
  sort.forEach(({ key, order }) => transformedSortParams.push(`${key}:${order}`));
  return transformedSortParams.join(',');
};

const getUrl = ({
  host,
  projectId,
  page,
  size,
  search,
  sort,
}: {
  host: string;
  projectId: string;
  page: number;
  size: number;
  search?: string;
  sort: AccessDeviceSortModel[];
}) => {
  const params = new URLSearchParams();
  page && params.append('page[number]', `${page}`);
  size && params.append('page[size]', `${size}`);
  !!search && params.append('search', search);
  !!sort.length && params.append('sort', getSortParams(sort));

  return `${host}/devices/access/project/${projectId}/list?${params}`;
};

export const GetAccessDevicesListByProjectId = async ({
  host,
  token,
  projectId,
  page,
  size,
  search,
  sort,
}: {
  host: string;
  token: string;
  projectId: string;
  page: number;
  size: number;
  search?: string;
  sort: AccessDeviceSortModel[];
}): Promise<AccessDevicesListResponseModel> => {
  try {
    const url = getUrl({ host, projectId, page, size, search, sort });
    const options: AxiosRequestConfig = {
      url,
      method: 'GET',
      timeout: 10000,
      headers: {
        Accept: 'application/json, text/plain, */*',
        'Content-Type': 'application/json;charset=UTF-8',
        Authorization: token,
        'Accept-version': '1',
      },
    };

    const { data } = (await axios(options)) as AxiosResponse<AccessDevicesListResponsePayload>;
    return payloadToAccessDevicesListByProjectIdResponse(data);
  } catch (error) {
    throw getErrorFormat(error);
  }
};
